import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { Header } from "@/components/Header";
import { Text } from "@/components/Text";
import { Flex, IDialogModal, Img, inDialogModal } from "@/eworkitComponents";
import { useToggle } from "@/hooks/Toggle";
import { CloseButton } from "@/views/components/CloseButton";
import { CompanyCreator } from "@/views/components/Company/Create";
import { StyledModal } from "@/views/components/Modal";

import requestToJoinSentSvg from "./assets/request-to-join-sent.svg";

import "./_create-company-dialog-modal.scss";

interface ICreateCompanyDialogProps extends IDialogModal {}

const CreateCompanyDialog: FC<ICreateCompanyDialogProps> = ({ ...openableProps }) => {
  const { t } = useTranslation("session");

  const [askToJoinSent, toggleAskToJoinSent] = useToggle(false);

  const baseClassName = "create-company-dialog-modal";

  return (
    <StyledModal className={baseClassName}>
      <Flex direction="column" margin={["xl"]} innerMargin="lg">
        <Flex justify="space-between">
          <Header size="md" color="black" weight="bold">
            {askToJoinSent ? t("COMPANY.CREATE.ASK_TO_JOIN_SUCCESS_HEADER") : t("COMPANY.CREATE.HEADER")}
          </Header>
          <CloseButton onClick={openableProps.onClose} testName="close" />
        </Flex>

        {askToJoinSent ? (
          <>
            <Flex direction="column" align="center" justify="center" innerMargin="lg">
              <Img src={requestToJoinSentSvg} />
              <Flex direction="column">
                <Text size="md" color="black" align="center">
                  {t("COMPANY.CREATE.ASK_TO_JOIN_SUCCESS")}
                </Text>
              </Flex>
            </Flex>
            <Flex justify="flex-end">
              <Button variant="secondary" size="lg" testName="cancel-ask-to-join" onClick={openableProps.onClose}>
                {t("COMPANY.CREATE.BUTTON_CLOSE")}
              </Button>
            </Flex>
          </>
        ) : (
          <CompanyCreator
            onCompanyCreated={openableProps.onClose}
            onAskToJoinSent={toggleAskToJoinSent}
            onCancel={openableProps.onClose}
          />
        )}
      </Flex>
    </StyledModal>
  );
};

const CreateCompanyDialogModalComponent = inDialogModal(CreateCompanyDialog);

interface ICreateCompanyDialogModalProps extends ICreateCompanyDialogProps {}

export const CreateCompanyDialogModal: FC<ICreateCompanyDialogModalProps> = props => {
  return <CreateCompanyDialogModalComponent size="xs" fixedHeight {...props} />;
};
